import { BASE_URL } from './Config.js';

export class AchatService {

   fetchToutesCommandes = async () => {
    const token = localStorage.getItem('accessToken');
    
    //  LOGS DE DÉBOGAGE CRUCIAUX
    
    console.log("🔍 [AchatService] Token présent ?", token ? `OUI (${token.length} chars)` : "NON ");

    if (!token) throw new Error('No access token found. Please login again.');

    const url = `${BASE_URL}/achatLine/all`;
  

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.error(`[AchatService] HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  };

 
  // ── Fetch lignes à acheter ───────────────────────────────────────────────────
  fetchAAcheter = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achatLine/a_acheter`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Failed to fetch à acheter:', error);
      throw error;
    }
  };

  // ── Fetch commandes clôturées ────────────────────────────────────────────────
  fetchAchatLineCloturees = async (achat_id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achatLine/achatLines_cloturees`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Failed to fetch commandes clôturées:', error);
      throw error;
    }
  };

  // ── POST envoi en masse ──────────────────────────────────────────────────────
  //Envoie une demande de quota en masse à un ou plusieurs fournisseurs
  // Dans src/services/AchatService.js (ou NotificationService.js)

sendMassQuota = async (payload) => {
  const token = localStorage.getItem('accessToken');
  
  if (!token) {
    throw new Error("Aucun token d'authentification trouvé. Veuillez vous reconnecter.");
  }

  const response = await fetch(`${BASE_URL}/notifications/quota-mass`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });

  // 🟢 1. On récupère d'abord la réponse sous forme de texte brut
  const responseText = await response.text();

  if (!response.ok) {
    // 🟢 2. On essaie de parser en JSON, sinon on utilise le texte brut comme message d'erreur
    let errorMessage = responseText;
    try {
      const errorData = JSON.parse(responseText);
      errorMessage = errorData.message || responseText;
    } catch (e) {
      // Ce n'est pas du JSON, on garde le texte brut
    }
    throw new Error(errorMessage || "Erreur lors de l'envoi de la demande de quota");
  }
  
  // 🟢 3. En cas de succès, on essaie de parser en JSON. 
  // Si ça échoue (parce que c'est du texte brut), on retourne simplement le texte.
  try {
    return JSON.parse(responseText);
  } catch (e) {
    return { message: responseText }; // On l'enveloppe dans un objet pour rester cohérent
  }
};



  // ── POST envoi WhatsApp pour une ligne ──────────────────────────────────────
  postWhatsApp = async (ligne_id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achatLine/${ligne_id}/whatsapp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Une erreur est survenue');
        } else {
          const text = await response.text();
          throw new Error(text || 'Erreur serveur inconnue');
        }
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error envoi WhatsApp:', error);
      throw error;
    }
  };

  // ── POST envoi email pour une ligne ─────────────────────────────────────────
  postEmail = async (ligne_id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achatLine/${ligne_id}/email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Une erreur est survenue');
        } else {
          const text = await response.text();
          throw new Error(text || 'Erreur serveur inconnue');
        }
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error envoi email:', error);
      throw error;
    }
  };

  // ── POST clôture d'une ligne ─────────────────────────────────────────────────
  postClot = async (ligne_id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achatLine/${ligne_id}/clot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Une erreur est survenue');
        } else {
          const text = await response.text();
          throw new Error(text || 'Erreur serveur inconnue');
        }
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error clôture ligne:', error);
      throw error;
    }
  };

 
  /*
  deleteData = async (ligne_id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error('No access token found');

      const response = await fetch(`${BASE_URL}/achat/${ligne_id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Failed to delete ligne');

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting ligne:', error);
      throw error;
    }
  };
  */

}